module.exports = __webpack_public_path__ + "fullstory.c0815f.svg";